<template>
  <div
    id="app"
    class='appBox'
  >
    <router-view />
  </div>
</template>
<script>
import {getRedirectParam} from '@/api/qrcode'
import {getCookie, setCookie, clearAllCookie } from '@/utils/tool'
import qs from "qs";
export default {
  data() {
    return {
    }
  },
  computed: {
    domainInfo() {
      return this.$store.state.domainInfo
    }
  },
  mounted() {
    const self = this
    const { protocol, origin,  pathname, hostname, search, href} = window.location
    window.addEventListener('message',function(e){
      if(origin == e.origin) {
        return
      }
      if(e.data.type == 'cookie') {
        clearAllCookie()
        setCookie('SESSION', e.data.session, 360)
        self.getRedirectParam()
      }
    },false)
  },
  methods: {
    async getRedirectParam(){
      const session = getCookie('SESSION')
      const redirectType = sessionStorage.getItem('redirectType')
      const { protocol, origin,  pathname, hostname, href} = window.location
      const content = href
      try {
        const params = {
          content
        }
        const res = await getRedirectParam(params)
        // const res = this.domainInfo

        /** 获取中间域名 和落地域名 */
        const { query } = this.$route
        const newQuery = `entry=${query.entry || ''}&inviteCode=${query.inviteCode || ''}&oauthId=${query.oauthId || ''}&token=${query.token || ''}`
        // 不是落地域名了 即A域名 已经获取到cookie 需求到b2域名设置cookie
        const url = `${protocol}//${res.mdata.landingDomain}/ql/${this.$route.params.id}`

        if(res.mdata.redirectType == 1) {
          /** 跳转b域名 */
           window.location.href = `${protocol}//${res.mdata.callBackDomain}/two.html?redirectUrl=${url}&session=${session}&${newQuery}`
           return
        }

        window.location.href = `${url}?session=${session}&${newQuery}`

        /** 判断是否需要跳转b域名 */
        /*if(res.mdata.landingDomain == hostname) {
          // 同一个域名
          if(query.token) {
            localStorage.setItem('token', query.token)
          }
          this.$router.push({
            name: 'land',
            params: this.$route.params,
            query: {
              session: getCookie('SESSION'),
              ...qs.parse(newQuery),
            }
          })
        } else {
          // 跳转落地域名
          window.location.href = `${url}?session=${session}&${newQuery}`
        }*/

      } catch (error) {

      }
    },
  }
}
</script>
<style lang="less">
  // #app {
  //   overflow: hidden;
  //   width: 100vw;
  // }
  * {
    padding: 0;
    margin: 0;
  }
  .vc-switch {
    font-size: 50px !important;
  }

</style>
